/* =====================================================
   GullyLabs Custom Lightbox — Desktop Only
   Fullscreen white overlay, centered image,
   bottom nav bar with [← 6/9 →]
   ===================================================== */

(function () {
    'use strict';

    // Only run on desktop
    if (window.innerWidth < 750) return;

    let currentIndex = 0;
    let images = [];
    let lightboxEl = null;
    let lightboxImg = null;
    let counterEl = null;

    function collectImages() {
        const gallery = document.querySelector('.gully-grid-gallery');
        if (!gallery) return [];

        const imgEls = gallery.querySelectorAll('.product__media-list .product__media-item .product__media img');
        const srcs = [];
        imgEls.forEach(function (img) {
            // Get the highest resolution src
            let src = img.getAttribute('src') || '';
            // Remove size constraints to get full resolution
            src = src.replace(/&width=\d+/, '&width=1200');
            if (src && !srcs.includes(src)) {
                srcs.push(src);
            }
        });
        return srcs;
    }

    function createLightbox() {
        // Overlay
        lightboxEl = document.createElement('div');
        lightboxEl.id = 'gully-lightbox';
        lightboxEl.innerHTML = `
      <div class="gully-lightbox__close" role="button" tabindex="0" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <div class="gully-lightbox__image-container">
        <img class="gully-lightbox__image" src="" alt="Product image" />
      </div>
      <div class="gully-lightbox__nav">
        <div class="gully-lightbox__nav-btn gully-lightbox__prev" role="button" tabindex="0" aria-label="Previous image">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </div>
        <span class="gully-lightbox__counter">1 / 1</span>
        <div class="gully-lightbox__nav-btn gully-lightbox__next" role="button" tabindex="0" aria-label="Next image">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </div>
      </div>
    `;

        document.body.appendChild(lightboxEl);

        lightboxImg = lightboxEl.querySelector('.gully-lightbox__image');
        counterEl = lightboxEl.querySelector('.gully-lightbox__counter');

        // Event listeners
        lightboxEl.querySelector('.gully-lightbox__close').addEventListener('click', closeLightbox);
        lightboxEl.querySelector('.gully-lightbox__prev').addEventListener('click', prevImage);
        lightboxEl.querySelector('.gully-lightbox__next').addEventListener('click', nextImage);

        // Click overlay to close (but not on image or nav)
        lightboxEl.addEventListener('click', function (e) {
            if (e.target === lightboxEl || e.target.classList.contains('gully-lightbox__image-container')) {
                closeLightbox();
            }
        });

        // Keyboard nav
        document.addEventListener('keydown', function (e) {
            if (!lightboxEl || lightboxEl.style.display !== 'flex') return;
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowLeft') prevImage();
            if (e.key === 'ArrowRight') nextImage();
        });
    }

    function openLightbox(index) {
        images = collectImages();
        if (!images.length) return;

        currentIndex = Math.max(0, Math.min(index, images.length - 1));

        if (!lightboxEl) createLightbox();

        updateImage();
        lightboxEl.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        // Prevent the default Dawn modal from opening
        setTimeout(function () {
            var dawnModal = document.querySelector('product-modal');
            if (dawnModal && dawnModal.style.display !== 'none') {
                dawnModal.style.display = 'none';
            }
            // Close any open Dawn modal dialogs
            var dialogEls = document.querySelectorAll('.product__modal .modal__dialog');
            dialogEls.forEach(function (d) { d.close && d.close(); });
        }, 50);
    }

    function closeLightbox() {
        if (lightboxEl) {
            lightboxEl.style.display = 'none';
        }
        document.body.style.overflow = '';
    }

    function updateImage() {
        if (!lightboxImg || !counterEl) return;
        lightboxImg.src = images[currentIndex];
        counterEl.textContent = (currentIndex + 1) + ' / ' + images.length;
    }

    function prevImage() {
        if (images.length === 0) return;
        currentIndex = (currentIndex - 1 + images.length) % images.length;
        updateImage();
    }

    function nextImage() {
        if (images.length === 0) return;
        currentIndex = (currentIndex + 1) % images.length;
        updateImage();
    }

    // Intercept clicks on gallery images (desktop only)
    function attachClickHandlers() {
        if (window.innerWidth < 750) return;

        var gallery = document.querySelector('.gully-grid-gallery');
        if (!gallery) return;

        var mediaItems = gallery.querySelectorAll('.product__media-list .product__media-item');
        mediaItems.forEach(function (item, index) {
            // Block the default Dawn modal-opener behavior
            var modalOpener = item.querySelector('modal-opener');
            if (modalOpener) {
                modalOpener.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    openLightbox(index);
                }, true);
            }

            // Also handle direct image clicks
            var img = item.querySelector('.product__media img');
            if (img) {
                img.style.cursor = 'zoom-in';
                img.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    openLightbox(index);
                });
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(attachClickHandlers, 500);
        });
    } else {
        setTimeout(attachClickHandlers, 500);
    }
})();
